<template>
  <div class="scrollable" ref="scrollable">
    <div class="tw-container min-h-screen" style="flex-grow: 1">
      <SimplifiedHeroNew
        :title="onboardingTextConfig.spottingAreasSimplifiedTitle"
        :subtitle="onboardingTextConfig.spottingAreasSimplifiedSubtitle"
      />
      <ModernFiltersBar
        :search-query="searchQuery"
        @update:search-query="searchQuery = $event"
        :placeholder="$t('spotting_area_search_placeholder')"
        @clear-search="clearSearch"
        @clear-all="clearSearch"
      />

      <div class="communities__card-container" id="introjs-all-spotting-areas">
        <div v-if="!loading && spottingAreas && (filteredAccessibleSpottingAreas.length > 0 || filteredNonAccessibleSpottingAreas.length > 0)">
          <!--          <h1 v-if="filteredAccessibleSpottingAreas.length > 0 && isPortfolioMember && !isForwardFooding">My {{ spottingAreasLabel }}</h1>
                    <h1 v-else-if="filteredAccessibleSpottingAreas.length > 0 && !isForwardFooding">{{ spottingAreasLabel }}</h1>-->
          <div v-if="filteredAccessibleSpottingAreas.length > 0" class="row">
            <div class="col-xs-12 col-sm-4" v-for="(spottingArea, index) in filteredAccessibleSpottingAreas" :key="index">
              <div style="width: 100%; height: calc(100% - 20px); padding: 0px 10px 10px 10px">
                <simplified-image-card
                  v-if="spottingArea.user_has_access"
                  :name="spottingArea.name" :full-size="true"
                  background-color="white"
                  :image="getImageForSpottingArea(spottingArea)"
                  :sub-title="spottingArea.description"
                  :link="'/spotting-areas/' + spottingArea.id"
                  class="spotting-area-simplified-image-card"
                  :left-align-text="true"
                  :tags="getSpottingAreaTags(spottingArea)"
                />
              </div>
            </div>
          </div>

          <h1 v-if="filteredNonAccessibleSpottingAreas.length > 0 && !isForwardFooding">Other interesting {{ spottingAreasLabel }}</h1>
          <div v-if="filteredNonAccessibleSpottingAreas.length > 0 && !isForwardFooding" class="row">
            <div class="col-xs-12 col-sm-4" v-for="(spottingArea, index) in filteredNonAccessibleSpottingAreas" :key="index">
              <div style="width: 100%; height: calc(100% - 20px); padding: 0px 10px 10px 10px">
                <template v-if="spottingArea.user_can_login_or_upgrade">
                  <simplified-image-card-with-cta
                    :spotting-area="spottingArea"
                  />
                </template>
                <template v-else>
                  <simplified-image-card
                    :name="spottingArea.name" :full-size="true"
                    background-color="white"
                    :image="getImageForSpottingArea(spottingArea)"
                    :sub-title="spottingArea.description"
                    class="spotting-area-simplified-image-card"
                    :left-align-text="true"
                    :disabled="true"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- No Search Results -->
        <div v-else-if="!loading && spottingAreas && searchQuery && filteredAccessibleSpottingAreas.length === 0 && filteredNonAccessibleSpottingAreas.length === 0"
             class="text-center py-12">
          <h2 class="text-2xl text-gray-600 mb-4">No spotting areas found</h2>
          <p class="text-gray-500">Try adjusting your search query</p>
        </div>
        <div v-else-if="loading">
          <Loading/>
        </div>
        <div v-else-if="spottingAreas && accessibleSpottingAreas.length === 0 && nonAccessibleSpottingAreas.length === 0">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SimplifiedHeroNew from '../components/SimplifiedHero/SimplifiedHeroNew.vue'
  import Container from '../components/Container/Container.vue'
  import SimplifiedImageCard from '../components/Connection/SimplifiedImageCard.vue'
  import SimplifiedImageCardWithCta from '../components/SpottingAreas/SimplifiedImageCardWithCta.vue'
  import { Carousel, Navigation, Slide } from 'vue3-carousel'
  import FollowButton from '../components/FollowButton/FollowButton.vue'
  import PublishButton from '../components/PublishButton/PublishButton.vue'

  import CommunityCard from '../components/Simplified/CommunityCard.vue'
  import Loading from '../components/Dashboard/ConceptMap/Loading.vue'
  import { getImageForSpottingArea, truncate } from '../util/helpers.js'
  import OnboardingMixin from '../util/OnboardingMixin.js'
  import { followSpottingArea, unfollowSpottingArea } from '../api/exploration.js'
  import SimplifiedFooter from '../components/SimplifiedFooter/SimplifiedFooter.vue'
  import IntroJsMixin from '../util/IntroJsMixin.js'
  import { ACTION_TYPES as SPOTTING_AREAS_ACTION_TYPES } from '../store/modules/spottingareas.js'
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../store/modules/ui.js'
  import { defineComponent } from 'vue'
  import ModernFiltersBar from '../components/Filters/ModernFiltersBar.vue'

  export default defineComponent({
    name: 'SpottingAreas',
    data () {
      return {
        spottingAreaIsFollowed: [],
        accessibleSpottingAreas: [],
        nonAccessibleSpottingAreas: [],
        searchQuery: '',
      }
    },
    computed: {
      isForwardFooding () {
        return ['forwardfooding', 'local'].includes(this.$store.getters.ecosystemName.toLowerCase())
      },
      hasAccessToNewSpottingAreas () {
        return this.$store.getters.hasAccessToNewSpottingAreas
      },
      subscriptionInfo () {
        return this.$store.state.user.profile.subscriptionInfo || {}
      },
      isLoggedIn () {
        return this.$store.getters.isLoggedIn
      },
      isActor () {
        return this.$store.getters.isActor
      },
      isMember () {
        return this.$store.getters.isMember
      },
      isPortfolioMember () {
        return this.$store.getters.isPortfolioMember
      },
      spottingAreas () {
        let spottingareas = this.$store.state.spottingAreas.listData.data

        if (spottingareas.length > 0) {
          spottingareas = [...spottingareas].sort((a, b) => b.user_has_access - a.user_has_access)
          spottingareas = [...spottingareas].sort((a, b) => b.type - a.type)

          if (spottingareas.length > 0) {
            this.accessibleSpottingAreas = spottingareas.filter(spottingArea => spottingArea.user_has_access === true)
            this.accessibleSpottingAreas = this.accessibleSpottingAreas.sort((a, b) => {
              return (a.spotting_area_access < b.spotting_area_access ? -1 : (a.spotting_area_access > b.spotting_area_access ? 1 : 0))
            })
            this.nonAccessibleSpottingAreas = spottingareas.filter(spa => spa.user_has_access === false)
          }
        }

        return spottingareas
      },
      loading () {
        return this.$store.state.spottingAreas.listData.loading
      },
      filteredAccessibleSpottingAreas () {
        if (!this.searchQuery.trim()) {
          return this.accessibleSpottingAreas
        }

        const query = this.searchQuery.toLowerCase()
        return this.accessibleSpottingAreas.filter(area => {
          return area.name.toLowerCase().includes(query) ||
            (area.description && area.description.toLowerCase().includes(query))
        })
      },
      filteredNonAccessibleSpottingAreas () {
        if (!this.searchQuery.trim()) {
          return this.nonAccessibleSpottingAreas
        }

        const query = this.searchQuery.toLowerCase()
        return this.nonAccessibleSpottingAreas.filter(area => {
          return area.name.toLowerCase().includes(query) ||
            (area.description && area.description.toLowerCase().includes(query))
        })
      }
    },
    methods: {
      truncate,
      getImageForSpottingArea,
      clearSearch () {
        this.searchQuery = ''
      },
      async fetchSpottingAreas () {
        if (this.spottingAreas.length === 0) {
          await this.$store.dispatch(SPOTTING_AREAS_ACTION_TYPES.FETCH_SPOTTING_AREAS_LIST)
          setTimeout(() => {
            this.startIntroJs()
            // This timeout is required to wait for the simplifiedImageCard timeout
          }, 200)
        } else {
          // timeout to prevent two introJS instances at once after final personal home "afterClick"
          setTimeout(() => {
            this.startIntroJs()
          })
        }
      },
      isFollowed (spottingArea) {
        return this.spottingAreaIsFollowed[spottingArea.id]
      },
      setFollowed (spottingArea, followed) {
        if (followed) {
          this.followSpottingArea(spottingArea)
        } else {
          this.unfollowSpottingArea(spottingArea)
        }
      },
      showingPublishButton () {
        return this.isOwner
      },
      followSpottingArea (spottingArea) {
        followSpottingArea(spottingArea.id)
          .then(() => {
            this.spottingAreaIsFollowed[spottingArea.id] = true
          })
      },
      unfollowSpottingArea (spottingArea) {
        unfollowSpottingArea(spottingArea.id)
          .then(() => {
            this.spottingAreaIsFollowed[spottingArea.id] = false
          })
      },
      startIntroJs () {
        if (this.seenIntros.includes('spottingAreasHome')) {
          return
        }
        const config = this.buildIntroJsConfig(this.config, this.$store.getters.userRole)
        if (!config || !config.spottingAreasHome || !config.spottingAreasHome.steps) {
          return
        }

        config.spottingAreasHome.steps = this.getIntroJsStepsConfig(config.spottingAreasHome.steps)
        const intro = this.introJs().setOptions(config.spottingAreasHome)
        this.currentIntro = intro

        const componentScope = this
        intro.onbeforechange(this.introJsBeforeStepCallback.bind(this))
        intro.onafterchange(this.introJsAfterStepCallback.bind(this))
        intro.oncomplete(function () {
          componentScope.introJsOnCompleteCallback(this._options, this._currentStep, componentScope)
        })
        intro.onexit(function () {
          componentScope.introJsOnCompleteCallback(this._options, this._currentStep, componentScope)
        })

        intro.start()
      },
      getSpottingAreaTags (spottingArea) {
        const tags = []
        if (!this.isPortfolioMember || !spottingArea.spotting_area_access) {
          return tags
        }

        tags.push(spottingArea.spotting_area_access.charAt(0).toUpperCase() + spottingArea.spotting_area_access.slice(1))

        return tags
      },
    },
    async mounted () {
      if (!this.hasAccessToNewSpottingAreas) {
        this.$router.push('/')
      }
      await this.fetchSpottingAreas()
      this.$store.commit(UI_MUTATION_TYPES.SET_NAVIGATION_VISIBILITY, true)
    },
    mixins: [OnboardingMixin, IntroJsMixin],
    components: {
      SimplifiedHeroNew,
      Container,
      CommunityCard,
      Loading,
      Carousel,
      SimplifiedFooter,
      Navigation,
      Slide,
      SimplifiedImageCard,
      SimplifiedImageCardWithCta,
      FollowButton,
      PublishButton,
      ModernFiltersBar,
    },
  })
</script>

<style lang="scss" scoped>
  .communities-container {
    height: 100%;
    overflow: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .simplified-connection.disabled {
    filter: grayscale(100%);
  }
</style>
